import styled from 'styled-components';

import { TextView } from '@dreryk/react-components';

import { TEXT_VIEW_LABEL_TO_CONTENT_GAP } from './prescriptionGrid.constants';

export const StyledPrescriptionTextView = styled(TextView)`
   && {
      gap: ${TEXT_VIEW_LABEL_TO_CONTENT_GAP};
   }
`;

StyledPrescriptionTextView.displayName = 'StyledPrescriptionTextView';
